var $imports = require("../../../../../node_modules/art-template/lib/runtime.js");
module.exports = function ($data) {
    'use strict';
    $data = $data || {};
    var $$out = '', $escape = $imports.$escape, feedback = $data.feedback, foxitSoftware = $data.foxitSoftware, eduExclusive = $data.eduExclusive, helpCenter = $data.helpCenter;
    $$out += '<div class="fv__ui-mobile-toolbar-tab" tab="help">\n    <group-list name="help-toolbar-group-list">\n        <group name="help-tab-group-feedback" retain-count="1">\n            <ribbon-button name="';
    $$out += $escape(feedback.name);
    $$out += '" icon-class="';
    $$out += $escape(feedback.icon);
    $$out += '" text="';
    $$out += $escape(feedback.title);
    $$out += '" @cannotBeDisabled></ribbon-button>\n        </group>\n        <group name="help-tab-group-foxit-software" retain-count="1">\n            <ribbon-button name="';
    $$out += $escape(foxitSoftware.name);
    $$out += '" icon-class="';
    $$out += $escape(foxitSoftware.icon);
    $$out += '" text="';
    $$out += $escape(foxitSoftware.title);
    $$out += '" @cannotBeDisabled></ribbon-button>\n        </group>\n        <group name="help-tab-group-edu-exclusive" retain-count="1">\n            <ribbon-button name="';
    $$out += $escape(eduExclusive.name);
    $$out += '" icon-class="';
    $$out += $escape(eduExclusive.icon);
    $$out += '" text="';
    $$out += $escape(eduExclusive.title);
    $$out += '" @cannotBeDisabled></ribbon-button>\n        </group>\n        <group name="help-tab-group-help-center" retain-count="1">\n            <ribbon-button name="';
    $$out += $escape(helpCenter.name);
    $$out += '" icon-class="';
    $$out += $escape(helpCenter.icon);
    $$out += '" text="';
    $$out += $escape(helpCenter.title);
    $$out += '" @cannotBeDisabled></ribbon-button>\n        </group>\n    </group-list>\n</div>';
    return $$out;
};